import React from 'react';
import { useSelector } from 'react-redux';
import { t } from '../../../helpers/t';

export function ListingAvailabilityCalendar() {
  const { readable_lease, maximum_lease } = useSelector((state) => state.listing);


  return (
    <div id="availabilities-panel" className="px-4 md:px-0 py-6">
      <h2 id="availabilities" className="text-stone-900 text-2xl font-semibold mb-4">
        {t('listings.show.sections.availability.header')}
      </h2>

      <div className="flex text-md text-stone-900" itemProp="additionalProperty" itemScope itemType="http://schema.org/PropertyValue">
        <div className="font-light" itemProp="name">
          {t('listings.show.sections.information.minimum_rental')}
        </div>
        <div className="font-extralight ml-2" itemProp="value">
          {readable_lease.minimum_lease}
        </div>
      </div>

      {
        (maximum_lease > 0) && (
          <div className="flex text-md text-stone-900" itemProp="additionalProperty" itemScope itemType="http://schema.org/PropertyValue">
            <div className="font-light" itemProp="name">{t('listings.show.sections.information.maximum_rental')}</div>
            <div className="font-extralight ml-2" itemProp="value">{readable_lease.maximum_lease}</div>
          </div>
        )
      }
    </div>
  );
}
